import { AllowedDecimalsTooltip } from 'core/elements/AllowedDecimalsTooltip';

export const getCostInputProps = (decimals: number) => ({
  endDecorator: <AllowedDecimalsTooltip decimals={decimals} />,
  slotProps: {
    input: {
      prefix: '$',
      thousandSeparator: true,
      decimalScale: decimals,
      fixedDecimalScale: true,
    },
  },
});
